import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 70.86 48.24' {...props}>
    <g data-name='Layer 2'>
      <path
        d='M64.49 0H6.35A6.36 6.36 0 0 0 0 6.35v35.54a6.36 6.36 0 0 0 6.35 6.35H64.5a6.36 6.36 0 0 0 6.35-6.35V6.34A6.38 6.38 0 0 0 64.49 0zM6.35 3H64.5a3.34 3.34 0 0 1 3.34 3.34v2.12L38.16 29.91a4.62 4.62 0 0 1-5.47 0L3 8.46V6.34A3.35 3.35 0 0 1 6.35 3zm58.14 42.21H6.35A3.34 3.34 0 0 1 3 41.87v-29.7l27.94 20.17a7.51 7.51 0 0 0 9 0l27.9-20.17v29.7a3.35 3.35 0 0 1-3.35 3.34z'
        fill='undefined'
        data-name='general content'
      />
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/EmailIcon.js